import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getVentas } from 'services/servicioGet';
import { VentaListado } from 'utils/models/types';

interface VentasState {
  ventas: VentaListado[];
  loadingVentas: boolean;
  errorVentas: string | null;
}

// Estado inicial del slice
const initialState: VentasState = {
  ventas: [],
  loadingVentas: false,
  errorVentas: null,
};

// Thunk para obtener las ventas
export const fetchVentas = createAsyncThunk<VentaListado[]>('fetchVentas', async (_, { rejectWithValue }) => {
  try {
    const response = await getVentas();
    return response;
  } catch (error: unknown) {
    return rejectWithValue(error instanceof Error ? error.message : String(error));
  }
});

// Slice de ventas
const verntasSlice = createSlice({
  name: 'ventas',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchVentas.pending, state => {
        state.loadingVentas = true;
        state.errorVentas = null;
      })
      .addCase(fetchVentas.fulfilled, (state, action) => {
        state.ventas = action.payload;
        state.loadingVentas = false;
      })
      .addCase(fetchVentas.rejected, (state, action) => {
        state.loadingVentas = false;
        state.errorVentas = action.payload as string;
      });
  },
});

export default verntasSlice.reducer;
